import EdPresentationModeMixin from '@/content/mixins/ed-presentation-mode.mixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';

@Component({})
export default class EdPresentationModeUserBoardTitle extends Mixins(EdPresentationModeMixin) {

  get username() : string {
    return this.$store.state.MeetingsStore.currentBoardUser.fullName;
  }

  get isPresentationModeTeacher(){
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get userTitle() : string {    
    return (this.username && (this.currentBoardUser.isTeacher === false)) ?
      this.$i18n.t('meetings.presentationMode.userBoardTitle').toString().replace('{username}', this.username)
      : this.$i18n.t('meetings.presentationMode.teacherBoardTitle').toString();
  }
}